export default __webpack_public_path__ + "static/media/copy-chat.a5095fe3.svg";